import React from 'react';
import Dashboard from '../components/Dashboard';

const Index = () => {
  return (
    <main>
      <Dashboard />
    </main>
  );
};

export default Index;
